import type { DetailedSelection } from '../components/DetailedView/types'
import { elementIdToDetailedSelection } from '../components/DetailedView/diff'
import type { ManageWorkspaceMode } from '../components/Manage/ManageWorkspaceHeaderControls'

export const applyManageModeSwitch = (
  nextMode: ManageWorkspaceMode,
  current: ManageWorkspaceMode,
  setManageMode: (mode: ManageWorkspaceMode) => void,
  getManagePath: (mode: ManageWorkspaceMode) => string | null,
): void => {
  if (nextMode === current) return
  setManageMode(nextMode)
  const nextPath = getManagePath(nextMode)
  if (nextPath && typeof window !== 'undefined' && `${window.location.pathname}${window.location.search}` !== nextPath) {
    window.history.pushState(null, '', nextPath)
  }
}

export type MirrorSwitchResult =
  | { direction: 'toBoard'; pendingBoardOpenId: string | null; pendingBoardSelectOnlyId: string | null }
  | { direction: 'toReview'; detailedViewInitialFocus: DetailedSelection | null }

export const computeMirrorForSwitch = ({
  activeId,
  wasExpanded,
  direction,
  elements,
}: {
  activeId: string | null
  wasExpanded: boolean
  direction: 'toBoard' | 'toReview'
  elements?: Array<{ id: string; type: string; parentId?: string | null }>
}): MirrorSwitchResult => {
  if (direction === 'toBoard') {
    if (wasExpanded) {
      return { direction: 'toBoard', pendingBoardOpenId: activeId, pendingBoardSelectOnlyId: null }
    } else {
      return { direction: 'toBoard', pendingBoardOpenId: null, pendingBoardSelectOnlyId: activeId }
    }
  } else {
    return {
      direction: 'toReview',
      detailedViewInitialFocus: elementIdToDetailedSelection(activeId, elements ?? []),
    }
  }
}

export function selectionElementId(sel: DetailedSelection | null): string | null {
  if (!sel) return null
  if (sel.kind === 'subtask') return sel.subTaskId
  if (sel.kind === 'task') return sel.taskId
  if (sel.kind === 'goal') return sel.goalId
  return null
}
